module.exports = __webpack_public_path__ + "img/zhengshu_down.d84043f9.png";